import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../../lib/apiCaller";

export const validateAddress = createAsyncThunk(
  "location/validateAddress",
  async (payload, ThunkAPI) => {
    try {
      // const token = ThunkAPI.getState().auth.token;
      // if (!token) return ThunkAPI.rejectWithValue("No auth token found");

      const res = await callApi({
        key: "VALIDATE_ADDRESS",
        method: "POST",
        body: payload,
        // auth: true,
        useContent: true,
      });
      return res.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to validate address"
      );
    }
  }
);

const initialState = {
  city: "",
  latitude: null,
  longitude: null,
  addressLine1: "",
  addressLine2: "",
  state: "",
  country: "",
  postalCode: "",
  loading: false,
  error: null,
  validationResult: null,
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation: (state, action) => {
      state.city = action.payload.city;
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;

      state.addressLine1 = action.payload.addressLine1;
      state.addressLine2 = action.payload.addressLine2;
      state.state = action.payload.state;
      state.country = action.payload.country;
      state.postalCode = action.payload.postalCode;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.validationResult = action.payload;
      })
      .addCase(validateAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setLocation } = locationSlice.actions;
export default locationSlice.reducer;
